




































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import dayjs from "dayjs";
import {
  AddStockDto,
  CreateParamsDto,
} from "@/store/entities/gift-info-config";
import Ajax from "@/lib/ajax";
import GiftInfo from "@/store/entities/gift-info";

@Component
export default class CreateStockVM extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: CreateParamsDto, required: true }) params: CreateParamsDto;

  addStockInput: AddStockDto = new AddStockDto();

  giftList: GiftInfo[] = new Array<GiftInfo>();

  loading: boolean = false;

  async getGift(campaignId) {
    let response = await Ajax.get("/api/services/app/giftInfo/GetAll", {
      params: {
        maxResultCount: 1000,
        dataState: 1,
        campaignId: campaignId,
      },
    });
    this.giftList = response.data.result.items as Array<GiftInfo>;
  }

  async save() {
    if (!this.addStockInput.giftId) {
      this.notice("请选择奖品");
      return;
    }
    if (!this.addStockInput.startTime || !this.addStockInput.startTime) {
      this.notice("请选择时间");
      return;
    }

    if (!this.addStockInput) {
      this.notice("请选择奖品");
      return;
    }
    this.loading = true;

    this.addStockInput.packageId = this.params.packageId;

    this.addStockInput.startTime = dayjs(this.addStockInput.startTime).format(
      "YYYY-MM-DD"
    );

    this.addStockInput.endTime = dayjs(this.addStockInput.endTime).format(
      "YYYY-MM-DD 23:59:59"
    );

    await Ajax.post(
      "/api/services/app/GiftInfoConfig/AddStock",
      this.addStockInput
    );

    this.loading = false;

    this.$emit("save-success");
    this.$emit("input", false);
  }

  cancel() {
    (this.$refs.formVM as any).resetFields();
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    (this.$refs.formVM as any).resetFields();
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getGift(this.params.campaignId);
      this.addStockInput = new AddStockDto();
      if (this.params.startTime) {
        this.addStockInput.startTime = this.params.startTime;
        this.addStockInput.endTime = this.params.endTime;
      }
    }
  }

  notice(msg) {
    this.$Notice.info({
      title: "提示",
      desc: msg,
    });
  }
}
